// Imports
//=require jquery/dist/jquery.min.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require jquery-mask-plugin/dist/jquery.mask.min.js
//=require owl.carousel/dist/owl.carousel.min.js


// DOM
var MyApp = {

    onlyNumbers: function () {
        $('.only-numbers').on('keypress', function (event) {
            var numbers = /[0-9]/g;
            var key = String.fromCharCode(event.which);
            var other_keys = [8,9];
            if ($.inArray(event.keyCode, other_keys) >= 0 || numbers.test(key)) {
                return true;
            }
            return false;
        });
    },
    onlyLetters: function () {
        $('.only-letters').on('keypress', function (event) {
            var englishAlphabetAndWhiteSpace = /[A-Za-z- ]/g;
            var other_keys = [8, 9, 37, 39, 193, 225, 200, 232, 205, 237, 211, 243, 218, 250, 209, 241];
            var key = String.fromCharCode(event.which);
            if ($.inArray(event.keyCode, other_keys) >= 0 || englishAlphabetAndWhiteSpace.test(key)) {
                return true;
            }
            return false;
        });
    },
    quote: {
        form: function () {
            jQuery.validator.addMethod("validEmail", function (value) {
                if (value == '')
                    return true;
                var temp1;
                temp1 = true;
                var ind = value.indexOf('@');
                var str2 = value.substr(ind + 1);
                var str3 = str2.substr(0, str2.indexOf('.'));
                if (str3.lastIndexOf('-') == (str3.length - 1) || (str3.indexOf('-') != str3.lastIndexOf('-')))
                    return false;
                var str1 = value.substr(0, ind);
                if ((str1.lastIndexOf('_') == (str1.length - 1)) || (str1.lastIndexOf('.') == (str1.length - 1)) || (str1.lastIndexOf('-') == (str1.length - 1)))
                    return false;
                str = /(^[a-zA-Z0-9]+[\._-]{0,1})+([a-zA-Z0-9]+[_]{0,1})*@([a-zA-Z0-9]+[-]{0,1})+(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,3})$/;
                temp1 = str.test(value);
                return temp1;
            }, "Email is required");

            var zipcodeValue = $('[name="zipcode"]').val();
            $('.forms').each(function () {
                $(this).validate({
                    errorElement:'span',
                    errorClass: 'forms__error',
                    rules: {
                        fname: { minlength: 2 },
                        lname: { minlength: 2 },
                        email: { minlength: 3, maxlength: 255, validEmail: true },
                        phone: { minlength: 12, maxlength: 12 },
                        zipcode: {
                            digits: true,
                            minlength: 3,
                            maxlength: 5,
                            remote: {
                                url: 'https://www.freewaylms.com/controller/validation-zipcode.php?',
                                dataFilter: function (data) {
                                    if (data === "1") {
                                        return '"true"';
                                    }
                                    return '"Zip Code is required"';
                                }
                            }
                        }
                    },
                    messages: {
                        gender: {
                            required: 'Gender is required'
                        },
                        fname: {
                            required: 'First Name is required'
                        },
                        lname: {
                            required: 'Last Name is required'
                        },
                        email: {
                            required: 'Email is required'
                        },
                        phone: {
                            minlength: 'You must enter 10 digits',
                            maxlength: 'You must enter 10 digits',
                            required: 'Phone is required'
                        },
                        zipcode: {
                            required: 'Zip Code is required'
                        }
                    },
                    submitHandler: function(form) {
                        if (zipcodeValue !== '' ) {
                            $.getJSON('https://www.freewaylms.com/controller/validation-zipcode.php?callback=?',{
                                zipcode:$('[name="zipcode"]').val(), method :'json', return_data:'true'
                            },
                            function(data){
                                if (data.response == 1) {
                                    $('.form').addClass('forms__loading');
                                    form.submit();
                                } else {
                                    $('.error-zipcode').addClass('show-error').append('<span class="error">Zip Code is required</span>');
                                    $('.form').removeClass('forms__loading');
                                }
                            });
                        } else{
                            $('.form').addClass('forms__loading');
                            $('.error-zipcode').html('');
                            form.submit();
                        }
                    }
                });
            });
            if (zipcodeValue !== '' ) {
                $('[name="zipcode"]').rules('remove', 'remote');
            }
        },
        phone: function () {
            $('#phone').mask('000-000-0000');
        }
    },
    advisors: {
        carousel: function(){
            $('.advisors-slider__list').owlCarousel({
                loop:true,
                margin:0,
                nav:false,
                dots:false,
                items:1,
                autoplay:true,
                autoplayTimeout:3000,
            })
        }
    },
    giftCard: {
        close: function () {
            $('.gift-card-banner__close').on('click', function () {
                $('.gift-card-banner').slideUp();
            })
        }
    }
}
//OSANO
const osanoTrigger = {
    trigger: document.querySelector('.js-osano-trigger'),
    init() {
        this.trigger?.addEventListener('click', event => {
            event.preventDefault();
            Osano.cm.showDoNotSell();
            const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
            closeButtonDialog?.focus();
        });
    }
};

window.addEventListener('load', event => {
    osanoTrigger.init();
});

// On ready

$(function () {

    if ($('.only-numbers').length) {
        MyApp.onlyNumbers();
    }

    if ($('.only-letters').length) {
        MyApp.onlyLetters();
    }

    if ($('.forms').length) {
        MyApp.quote.form();
        MyApp.quote.phone();
    }

    if ($('.advisors-slider__list').length) {
        MyApp.advisors.carousel();
    }
    if ($('.gift-card-banner__close').length) {
        MyApp.giftCard.close();
    }
});